const Themes = {
  mainTheme: {
    name: "mainTheme",
    primary: "#004C97", //main background  CT
    primary2: "#006CB1", //hover na primary
    secondary: "white", //text on main background CS
    tertiary: "#000000", //common text CT
    quaternary: "#666666", //placeholderi i manje naglasene stvari, disabled buttoni CT
    quinary: "#F6F6F6", //main background
    septenary: "#FFFFFF", //secondary background
    octonary: "red", //error on page
  },

  secondaryTheme: {
    name: "secondaryTheme",
    primary: "#FFDEB9", //main background  CT
    primary2: "#FFDEB9", //hover na primary
    secondary: "black", //text on main background CS
    tertiary: "white", //common text CT
    quaternary: "gray", //placeholderi i manje naglasene stvari, disabled buttoni CT
    quinary: "#7149C6", //main background
    septenary: "#FFFFFF", //secondary background
    octonary: "red", //error on page
  },
};

export const allowedThemes = process.env.REACT_APP_THEMES.split(",");
export const themeExports = allowedThemes.map((theme) => {
  return { theme: theme, name: Themes[theme].name };
});
export default Themes;

//primary, secondary, tertiary, quaternary, quinary, senary, septenary, octonary, nonary, and denary
